import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { LoginComponent } from './components/login/login.component';
import { TokenExpiredInterceptor } from './service/token-expired.interceptor';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import {
  ProgressInterceptor,
  ProgressSpinnerService,
} from './service/progress-spinner.service';
import { HomepageComponent } from './components/homepage/homepage.component';
import { SharedModule } from './shared/shared.module';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccountsComponent } from './components/functions/accounts/accounts.component';
import { RatesComponent } from './components/functions/rates/rates.component';
import { PathPrefixInterceptor } from './service/path-prefix.interceptor';
import { APP_BASE_HREF } from '@angular/common';
import { AuthenticationService } from './service/authentication.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { applicationReducer } from './store/Application/ApplicationReducer';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ServerConfig } from './model/ServerConfig';
import { BaxterAuthModule } from '@baxter-jenkins/authenticator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UpdateStaticInfoWidgetModule } from '@baxter-jenkins/update-static-info-widget';
import { AngularCommonModule } from '@clearing-hub/angular-common';

export function init(authenticationService: AuthenticationService) {
  return (): Promise<ServerConfig> =>
    authenticationService.loadUserInfoFromServer();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomepageComponent,
    AccountsComponent,
    RatesComponent,
  ],
  imports: [
    AngularCommonModule.forRoot({ gridColumnsSize: 24 }),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,

    BaxterAuthModule.forRoot({
      loginUrl: '/api/authentication/login',
      logoutUrl: '/api/authentication/signout',
      userPoolConfigUrl: '/api/authentication/user-pool',
      isRegistrationEnabled: true,
      registerUrl: '/api/authentication/register',
    }),
    UpdateStaticInfoWidgetModule.forRoot(),
    TabsModule.forRoot(),
    SharedModule,
    ToastrModule.forRoot({
      // disableTimeOut: true
    }),
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    NgxDatatableModule.forRoot({
      messages: {
        emptyMessage: 'No data to display', // Message to show when array is presented, but contains no values
        totalMessage: 'total', // Footer total message
        selectedMessage: 'selected', // Footer selected message
      },
    }),
    StoreModule.forRoot({}),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
    }),
    StoreModule.forFeature('application', applicationReducer),
    ModalModule.forRoot(),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProgressInterceptor,
      multi: true,
      deps: [ProgressSpinnerService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PathPrefixInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenExpiredInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: init,
      deps: [AuthenticationService],
      multi: true,
    },
    {
      provide: APP_BASE_HREF,
      useValue: window['base-href'],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
